import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { DataSaveProgress } from './data-save-progress';
import { IResultState, IState } from '../../../interfaces';

export interface IDataSaveProgressProps {
  onError(response: Response): void;
}

export interface IDataSaveProgressStateProps extends IDataSaveProgressProps {
  readonly result: IResultState;
}

export type IDataSaveProgressConnectProps = IDataSaveProgressStateProps
  & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState, props: IDataSaveProgressProps): IDataSaveProgressStateProps {
  return { result: state.result, ...props };
}

export const DataSaveProgressContainer: React.ComponentClass<IDataSaveProgressProps>
  = ReactRedux.connect(mapStateToProps)(DataSaveProgress);
